import React, { cloneElement, useEffect, useState } from 'react';
import Modal from './Modal';
import ErrorMessage from './ErrorMessage';
import InfoMessage from './InfoMessage';
import SuccessMessage from './SuccessMessage';

export function openModal(modal) {
    window.dispatchEvent(new CustomEvent('xs_openModal', {detail: modal}));
}

if (!window.showModalPurchaseMessage) {
	window.showModalPurchaseMessage = function(message, type) {
        let component = null;
        switch (type) {
            case 'error':
                component = <ErrorMessage text={message} />
                break;
            default:
            case 'warning':
                component = <InfoMessage text={message} />
                break;
            case 'success':
                component = <SuccessMessage text={message} />
                break;
        }

		openModal(
            <Modal>
                {component}
            </Modal>
        );
	}
}

export default function ModalContainer() {
    const [modals, setModals] = useState([]);

    useEffect(() => {
        function add(e) {
            const uniqueId = +new Date();
            const modal = cloneElement(e.detail, {key: uniqueId, uniqueId});
            setModals(modals.concat(modal));
        }

        function remove(e) {
            setModals(prev => prev.filter(m => m.props.uniqueId !== e.detail));
        }

        window.addEventListener('xs_openModal', add);
        window.addEventListener('xs_closeModal', remove);
        return () => {
            window.removeEventListener('xs_openModal', add);
            window.removeEventListener('xs_closeModal', remove);
        };
    }, []);

    if (modals.length === 0) {
        return null;
    }

    return (
        <div className="c_38">
            {modals}
        </div>
    );
}
